/**
 * Pure Scentum — newsletter / "notify me" forms.
 * Submits Shopify's native customer form (`{% form 'customer' %}`) via
 * fetch so the page doesn't reload, then swaps in the section's own
 * success message. Wrap the Shopify form output in a container carrying
 * [data-ps-customer-form] and, optionally, [data-ps-success="..."]:
 *
 *   <div data-ps-customer-form data-ps-success="You're on the list.">
 *     {% form 'customer' %} ... {% endform %}
 *     <p class="ps-form-msg" data-ps-form-msg></p>
 *   </div>
 */
(function () {
  function handleSubmit(e) {
    var form = e.target;
    var wrapper = form.closest('[data-ps-customer-form]');
    if (!wrapper) return;
    e.preventDefault();

    var msgEl = wrapper.querySelector('[data-ps-form-msg]');
    var successText = wrapper.getAttribute('data-ps-success') || "You're on the list.";
    var submitBtn = form.querySelector('button[type="submit"]');

    if (submitBtn) submitBtn.disabled = true;

    fetch(form.action, {
      method: 'POST',
      body: new FormData(form),
      headers: { Accept: 'application/json' }
    })
      .then(function () {
        if (msgEl) msgEl.textContent = successText;
        form.reset();
      })
      .catch(function () {
        if (msgEl) msgEl.textContent = 'Something went wrong — please try again.';
      })
      .finally(function () {
        if (submitBtn) submitBtn.disabled = false;
      });
  }

  document.addEventListener('submit', function (e) {
    if (e.target.closest('[data-ps-customer-form]')) handleSubmit(e);
  });
})();
